module.exports = __webpack_public_path__ + "img/godwin.38c26d37.jpg";